import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useTranslations } from "../../providers/useTranslations";
import styles from "./VerticalLoader.module.scss";
export const VerticalLoader = ({ dataTestId, loaderText, className }) => {
    const { __ } = useTranslations();
    return (_jsxs("div", { "data-testid": dataTestId, className: classNames(styles.loaderContainer, className), children: [_jsx("div", { className: styles.progressBarContainer, children: _jsx("div", { className: styles.loaderProgressBar }) }), _jsx("div", { className: styles.loaderText, children: loaderText || __("hero.loading.text") })] }));
};
//# sourceMappingURL=VerticalLoader.js.map